import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const pageview = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/sobre-o-credito",
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: "IT:NL:NCC:CGI:SobreOCreditoRV",
    hashedCpf
  }

  trackPageview({ ga, ga4 })
}

const back = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/sobre-o-credito",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "sobre-o-credito-voltar",
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const advance = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/sobre-o-credito",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "sobre-o-credito-proximo",
    eventName: "click"
  }

  const segment = "Credit Info Sent"

  trackEvent({ segment, ga4 })
}

const iof = (hashedCpf, financeIOF) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/sobre-o-credito",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: `sobre-o-credito-financiar-iof-${financeIOF ? "nao" : "sim"}`,
    eventName: "click"
  }

  const ga = {
    label: `BTN:CGI:IOF${financeIOF == "true" ? "Sim" : "Não"}`,
    action: "CGI",
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

const referral = (value, hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/sobre-o-credito",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: `sobre-o-credito-indicacao-parceiro-${value}`,
    eventName: "click"
  }

  const ga = {
    label: `BTN:CGI:Indicacao${value === "sim" ? "Sim" : "Não"}`,
    action: "CGI",
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

export { pageview, back, advance, iof, referral }
